import { render, staticRenderFns } from "./banners-slot.vue?vue&type=template&id=4d1b5480&"
import script from "./banners-slot.vue?vue&type=script&lang=js&"
export * from "./banners-slot.vue?vue&type=script&lang=js&"
import style0 from "./banners-slot.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d1b5480')) {
      api.createRecord('4d1b5480', component.options)
    } else {
      api.reload('4d1b5480', component.options)
    }
    module.hot.accept("./banners-slot.vue?vue&type=template&id=4d1b5480&", function () {
      api.rerender('4d1b5480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/banners-slot/banners-slot.vue"
export default component.exports